import { useIntl } from 'react-intl';
import Layout from '../components/layout/layout';

const ArabicCopy = () => (
  <>
    <h1>أحكام وشروط بطاقات رسال الرقمية</h1>

    <p>
      خدمة رسال للبطاقات الرقمية تمكنك من شراء بطاقة رقمية يتم إرسالها إلى بريدك
      الإلكتروني أو الرسائل النصية.
    </p>

    <h4>وقت ارسال البطاقة الرقمية</h4>

    <p>
      يتم ارسال البطاقات الرقمية بشكل فوري و خلال 15 دقيقة كحد أقصى من الوقت
      المجدول للإرسال في حال كان إجمالي قيمة الطلب أقل من ألفين ريال (2000) وفي
      حال كان أكثر من ذلك قد يستغرق وصول الأكواد 1-5 ساعات بعد التأكد من معلومات
      الشراء و امتلاكك لوسيلة الدفع المستخدمة.
    </p>

    <h4>استخدام وسيلة دفع بإسم شخص آخر</h4>
    <p>
      في حال تم التأكد من استخدامك لبطاقة إئتمانية أو وسيلة دفع لا تمتلكها لشراء
      البطاقة الرقمية، يحق لرسال إلغاء الطلب بدون أي التزامات.
    </p>

    <h4>تعديل الطلب</h4>
    <p>
      لا يمكن تعديل معلومات طلب البطاقة الرقمية ويشمل ذلك اسم المستقبل، رقم
      الجوال، نص رسالة الإهداء، البريد الإلكتروني، أو أي معلومات أخرى في الطلب
    </p>

    <h4>إلغاء الطلب</h4>
    <p>
      لايمكن إلغاء طلبات البطاقات الرقمية حتى لو كانت مجدولة للإرسال في تاريخ
      مستقبلي.
    </p>

    <h4>استرجاع او استبدال الطلب</h4>
    <p>
      بسبب طبيعة المنتج الحساسة فإنه لا يمكن استرجاع أو استبدال أي منتج من
      منتجات البطاقات الرقمية بعد شراءها في أي حال من الأحوال إلا في حالة ثبوت
      وجود مشكلة في المنتج أو البطاقة و ذلك في مدة تتراوح بين 2-5 أيام عمل و يتم
      التعويض بكود آخر مماثل للقيمة المطلوبة في حال ثبوت وجود المشكلة.
    </p>

    <h4>مشكلة في البطاقة</h4>
    <p>
      في حال وجود أي مشكلة في البطاقة الرقمية أو الكود المرسل يجب على العميل
      التأكد من استخدام الخطوات المذكورة في طريقة استخدام البطاقة المرسلة مع
      البطاقة أو الرجوع إلى المقالات التعريفية الموجودة في مدونة رسال من أسفل
      الموقع و في حال استمرار المشكلة يتم التواصل مع فريق خدمة العملاء عن طريق
      شات الموقع وسوف يتم التواصل مع شركاء رسال بخصوص المشكلة على أن يتم الرد
      خلال 5-7 أيام عمل في جميع المشاكل المتعلقة بالبطاقات الرقمية.
    </p>
    <p>
      <span className="font-medium">ملاحظة: </span>
      في حال تبين أنه تم بالفعل استخدام الكود المرسل بعد تاريخ و وقت الشراء من
      رسال لا تتحمل رسال أي مسؤولية تعويض تجاه العميل.
    </p>

    <h4>انتهاء صلاحية البطاقة الرقمية</h4>
    <p>
      لا يمكن استرداد قيمة البطاقات الرقمية في حال عدم استخدامها قبل تاريخ
      الانتهاء الموضح مع البطاقة وتعود مسؤولية ذلك للعميل.
    </p>

    <h4>رسوم الخدمة</h4>
    <p>
      هي رسوم يتم تحصيلها مقابل الخدمات الإضافية التي تقدمها رسال مثل تخصيص
      رسالة إهداء وجدولة الإرساليات وغيرها ,وغير قابلة للإسترداد
    </p>

    <h4>استخدام البطاقة الرقمية بما يخالف هذه الأحكام والشروط</h4>
    <p>
      باستخدامك البطاقة الرقمية ، فإنك توافق على الالتزام بهذه الأحكام والشروط،
      وعدم استخدامها بأي طريقة مضللة أو خادعة أو غير عادلة أو ضارة نحن نحتفظ
      بالحق، دون إخطارك، بإلغاء البطاقة الرقمية دون استرداد أو تعليق أو إنهاء
      حسابات العملاء أو تعليق أو إنهاء القدرة على استخدام خدماتنا أو الإلغاء أو
      الحد من الطلبات إذا اشتبه لنا أن البطاقة الرقمية قد تم الحصول عليها أو
      استخدامها أو تطبيقها على حساب رسال بطريقة احتيالية أو غير قانونية أو
      بطريقة أخرى تخالف هذه الأحكام والشروط
    </p>
    <p>
      تواصل معنا:
      <br />
      في حال لديك اي ملاحظات او اقتراحات نحن موجود بخدمتك في كل وقت على الايميل
      التالي :<a href="mailto:cs@resal.me">cs@resal.me</a>
    </p>
  </>
);

const EnglishCopy = () => (
  <>
    <h1>Terms and Conditions for Resal Digital Gift Cards</h1>
    <p>
      Resal digital gift service allows you to give a digital gift card that is
      sent by email or SMS to anyone you want.
    </p>
    <h2>The amount of time taken to send a digital gift</h2>
    <p>
      Digital gifts are sent immediately and within 15 minutes from the
      scheduled time for sending if the total value of the order is less than
      two 2000 SAR, and if it is more than that, it may take 1-5 hours for the
      codes to arrive after purchase confirmation and validating your possession
      for the payment method used.
    </p>
    <h2>Using a payment method in someone else's name</h2>
    <p>
      If it is confirmed that you are using a credit card or a payment method
      that you do not own, Resal has the right to cancel the order without any
      obligations.
    </p>
    <h2>Editing order</h2>
    <p>
      The digital gift order information cannot be modified. This includes the
      recipient's name, mobile number, gift message text, email, or any other
      information in the order.
    </p>
    <h2>Canceling order</h2>
    <p>
      Digital gift orders cannot be canceled even if they are scheduled to be
      sent at a future date.
    </p>
    <h2>Refund or changing order</h2>
    <p>
      Because of the sensitive nature of the product, it is not possible to
      return or replace any of the gift card products after purchasing it in any
      case, unless it is proven that there is a problem with the product, within
      a period between 2-5 working days, and the compensation will be made with
      another similar code with the same value if the problem is proven.
    </p>
    <h2>Card problem</h2>
    <p>
      If there is any problem with the gift card or the code sent, the customer
      must make sure to follow the steps mentioned on how to use the card, or
      refer to the blogs or FAQ in Resal blog from the bottom of the site. If
      the problem persists, the customer service team is contacted bout through
      the website’s chat, and the support will be contacted regarding the
      problem, and the response will be made within 5-7 working days in all
      problems related to gift cards.
    </p>
    <p>
      <span className="font-medium">Note: </span>
      If the code sent was found to be already used after the date and time of
      purchase from Resal, Resal will not take any responsibility for
      compensation towards the customer.
    </p>
    <h2>Gift Card Expiration Date</h2>
    <p>
      The value of digital cards cannot be refunded if they are not used before
      the expiry date indicated with the card.
    </p>
    <h2>Service fee</h2>
    <p>
      It is a fee that is collected for additional services provided by Resal,
      such as personalizing a gift message, scheduling dispatches, etc., and it
      is not refundable.
    </p>
    <h2>
      The Use of any Gift Card in the violation of these Terms and Conditions
    </h2>
    <p>
      By using the gift cards, you agree to be bound by these Terms and
      Conditions, and not to use the gift cards in any way that is misleading,
      deceptive, unfair, or harmful. We reserve the right, without notifying
      you, to cancel gift cards without refund, suspend or terminate customer
      accounts, suspend, terminate the ability to use our services, cancel, or
      limit orders if we suspect that a gift card has been obtained, used, or
      applied to a Resal account illegally, or otherwise used in violation of
      these Terms and Conditions.
    </p>
    <h3>Connect with us:</h3>
    <p>
      In case you have any comments or suggestions, we are at your service all
      the time at the following email:{' '}
      <a href="mailto:cs@resal.me">cs@resal.me</a>
    </p>
  </>
);

export function ServiceAgreement() {
  const { locale } = useIntl();
  return (
    <Layout>
      <div className="max-w-4xl mx-auto prose">
        {locale === 'en' ? <EnglishCopy /> : <ArabicCopy />}
      </div>
    </Layout>
  );
}

export default ServiceAgreement;
